import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import Notifications from 'adminDashboard/common/notifications'

import {
  DashboardInfoStatisticForAdminResponse,
  NotificationItem,
  PlanPeriodDto,
  benefitPlanPeriods,
  getDashboardInfoStatisticForAdmin,
  getNotifications,
} from 'core'
import { NotificationType } from 'core/application/adminDashboard/notifications/getNotifications'

import { useLoginUserV2 } from 'common/hooks/useLoginUser'

import { Card, Col, Row, Skeleton } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'
import { ROUTE_PATHS } from 'common/routePaths'

import './styles.less'

type WelcomeProps = {
  planPeriodId: string
}

const WelcomeBox = (props: WelcomeProps) => {
  const { user } = useLoginUserV2()
  const { t: translate } = useTranslation()
  const history = useHistory()

  const {
    data: statisticInfo,
    isLoading: statisticInfoLoading,
    sendQuery: sendGetDashboardStatisticInfo,
  } = useQueryRequestV2<DashboardInfoStatisticForAdminResponse>({
    initialState: null,
    queryFn: () => getDashboardInfoStatisticForAdmin(props.planPeriodId),
  })
  const { data: planPeriods } = useQueryRequestV2<PlanPeriodDto[]>({
    initialState: null,
    queryFn: () => benefitPlanPeriods(),
  })
  const { data: notifications, sendQuery: sendGetNotifications } = useQueryRequestV2<NotificationItem[]>({
    initialState: null,
    queryFn: () => getNotifications(),
  })

  useEffect(() => {
    sendGetDashboardStatisticInfo(() => getDashboardInfoStatisticForAdmin(props.planPeriodId))
  }, [props.planPeriodId])

  return (
    <Skeleton active={true} loading={statisticInfoLoading}>
      <Card className="card-style t-welcome-box">
        <Row className="mb-24">
          <Col span={24}>
            <div className="color-gray-8 mb-4 t-welcome-user-name">
              {' '}
              {translate('admin-dashboard.home.perks-welcome.welcome')}, {user.firstName}
            </div>
            <h4 className="color-gray-9 text-semi-bold">Action needed</h4>
          </Col>
        </Row>
        <Notifications
          statisticInfo={statisticInfo}
          planPeriods={planPeriods}
          planPeriodId={props.planPeriodId}
          notifications={notifications}
        />

        {notifications &&
          notifications.length > 0 &&
          notifications.some((x) => x.notificationType !== NotificationType.PopUpForPremiumPlus) && (
            <a
              className="mt-4 px-0 underline"
              onClick={() => history.push(`${ROUTE_PATHS.ACTION_NEEDED}?planPeriodId=${props.planPeriodId}`)}
            >
              See all notifications
            </a>
          )}
      </Card>
    </Skeleton>
  )
}

export default WelcomeBox
